import { render, staticRenderFns } from "./dispatcherNav.vue?vue&type=template&id=fe71811a&scoped=true&"
import script from "./dispatcherNav.vue?vue&type=script&lang=js&"
export * from "./dispatcherNav.vue?vue&type=script&lang=js&"
import style0 from "./dispatcherNav.vue?vue&type=style&index=0&id=fe71811a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe71811a",
  null
  
)

export default component.exports